import { HomeActionTypes } from './types';
import { action } from 'typesafe-actions';

export const getEnquiriesStart = (payload: any) =>
  action(HomeActionTypes.GET_ENQUIRIES_START, payload);
export const getEnquiriesSuccess = (payload: any) =>
  action(HomeActionTypes.GET_ENQUIRIES_SUCCESS, payload);
export const getEnquiriesFailure = (error: string) =>
  action(HomeActionTypes.GET_ENQUIRIES_FAILURE, error);

export const searchJobIdUserRefStart = (payload: any) =>
  action(HomeActionTypes.SEARCH_JOB_ID_USER_REF_START, payload);
export const searchJobIdUserRefSuccess = (payload: any) =>
  action(HomeActionTypes.SEARCH_JOB_ID_USER_REF_SUCCESS, payload);
export const searchJobIdUserRefFailure = (error: string) =>
  action(HomeActionTypes.SEARCH_JOB_ID_USER_REF_FAILURE, error);

export const getTeamEnquirerListStart = (payload: any) =>
  action(HomeActionTypes.GET_TEAM_ENQUIRER_LIST_START, payload);
export const getTeamEnquirerListSuccess = (payload: any) =>
  action(HomeActionTypes.GET_TEAM_ENQUIRER_LIST_SUCCESS, payload);
export const getTeamEnquirerListFailure = (error: string) =>
  action(HomeActionTypes.GET_TEAM_ENQUIRER_LIST_FAILURE, error);

export const getCredentialStart = () =>
  action(HomeActionTypes.GET_CREDENTIAL_START);
export const getCredentialSuccess = (payload: string) =>
  action(HomeActionTypes.GET_CREDENTIAL_SUCCESS, payload);
export const getCredentialFailure = (error: string) =>
  action(HomeActionTypes.GET_CREDENTIAL_FAILURE, error);
